export const getTemplateId = (template: Template) => {
  if ('employeeMessageTemplateId' in template) {
    return template.employeeMessageTemplateId;
  }
  if ('templateId' in template) {
    return template.templateId;
  }
  if ('applicantTriggeredCommunicationId' in template) {
    return template.applicantTriggeredCommunicationId;
  }
  if ('commentTemplateId' in template) {
    return template.commentTemplateId;
  }
  return null;
};
